if (!customElements.get('product-card')) {
  class ComponentProductCard extends HTMLElement {
    constructor() {
      super()
      this.quickViewBtn = this.querySelector('.quick-view-trigger')
      this.swatches = this.querySelector('.inline-swatch-group')
      if(this.quickViewBtn)
        this.quickViewBtn.addEventListener('click', this.openQuickView.bind(this))
      if(this.swatches)
        this.swatches.querySelectorAll('input').forEach((input)=>{
          input.addEventListener('change', this.onSwatchChange.bind(this))
        })

      let imageContainer = this.querySelector('.image-container');
      if (imageContainer && imageContainer.querySelector('.hover-img')) {
        let hover = false;
        this.addEventListener('mouseleave', (e)=>{
          hover && (hover=false,imageContainer.classList.remove("hover"));
        });
        this.addEventListener('mousemove', (e)=>{
          let bounds = imageContainer.getBoundingClientRect();
          if (e.y>bounds.top && e.y<bounds.bottom && e.x>bounds.left && e.x<bounds.right) {
            hover || (hover=true,imageContainer.classList.add("hover"))
          } else {
            hover && (hover=false,imageContainer.classList.remove("hover"));
          }
        });
      }
    }

    openQuickView(e) {
      e.preventDefault()
      $s.showLoadingOverlay();
      var qvUrl = this.quickViewBtn.dataset.url;
      $s.get({
        url: qvUrl,
        success: (html)=>{
          var parser = new DOMParser();
          var doc = parser.parseFromString(html, "text/html");
          var section = doc.querySelector('.product-main-element').closest('.shopify-section');
          $s.openModal(section, 'product-quick-view');
          $s.globalEval(section);
        },
        always: (html)=>{
          $s.hideLoadingOverlay();
        }
      })
    }

    onSwatchChange() {
      var checkedOption = this.querySelector('.inline-swatch-group input:checked')
      var variantImg = checkedOption.dataset.variantImg
      var variantUrl = checkedOption.dataset.variantUrl
      var priceFinal = checkedOption.dataset.priceFinal
      var priceCompare = checkedOption.dataset.priceCompare
      var variantPrice = checkedOption.dataset.variantPrice
      if (variantPrice && typeof $s.getPromoDisplayPricePair === 'function') {
        var variant = {
          price: parseInt(variantPrice, 10),
          compare_at_price: parseInt(checkedOption.dataset.variantCompareAt || '0', 10)
        };
        var tags = $s.getProductTagsFromElement(this);
        var pair = $s.getPromoDisplayPricePair({ tags: tags, variant: variant, isSubscription: false });
        priceFinal = $s.formatMoney(pair.finalCents).replace('.00', '');
        priceCompare = pair.compareCents && pair.compareCents > pair.finalCents
          ? $s.formatMoney(pair.compareCents).replace('.00', '')
          : '';
      }

      this.querySelectorAll('.product-card-url').forEach(function(e){
        e.setAttribute('href', variantUrl)
      });
      if (this.quickViewBtn)
        this.quickViewBtn.setAttribute('data-url', variantUrl)
      var finalEl = this.querySelector('.final')
      if (finalEl) {
        finalEl.innerHTML = priceFinal
      }
      if(this.querySelector('.from')) {
        this.querySelector('.from').style.display = "none"
      }
      var compareEl = this.querySelector('.compare')
      if (compareEl) {
        if(priceCompare) {
          compareEl.innerHTML = priceCompare
          compareEl.classList.remove('hide')
          compareEl.style.display = "block"
        } else {
          compareEl.innerHTML = ''
          compareEl.classList.add('hide')
          compareEl.style.display = "none"
        }
      }
      if(variantImg) {
        this.querySelector('.img.main').setAttribute('srcset', variantImg)
      }
    }
  }
  customElements.define('product-card', ComponentProductCard);
}